import {
  Cake as CakeIcon,
  ContactMail as ContactMailIcon,
  ContactPhone as ContactPhoneIcon,
  MedicalInformation as MedicalInformationIcon,
  Person as PersonIcon,
} from '@mui/icons-material';
import { Box, TableCell, TableRow, Typography } from '@mui/material';
import { paramCase } from 'change-case';
import CustomLink from 'src/careflow/common/CustomLink';
import Label from 'src/components/Label';
import { PATH_DASHBOARD } from 'src/routes/paths';

type Props = {
  row: any;
};

export default function EpisodeOfCareRow({ row }: Props) {
  const {
    eocId,
    fhirId,
    internalNumber,
    workflowStatus,
    workflowStageName,
    indexedsubjectMrn,
    indexedsubjectFullName,
    subjectDOBFormatted,
    subjectAge,
    indexedsubjectPhone,
    indexedsubjectEmail,
    createdOnFormatted,
  } = row;

  return (
    <TableRow key={eocId}>
      <TableCell>
        <CustomLink to={PATH_DASHBOARD.crs.episodeOfCare.details(paramCase(fhirId!))}>
          <Typography noWrap variant="subtitle2">
            {internalNumber}
          </Typography>
        </CustomLink>
      </TableCell>

      <TableCell>
        <Box display={'flex'} justifyContent={'row'}>
          <MedicalInformationIcon sx={{ marginRight: 1 }} fontSize={'small'} />
          <Typography variant="subtitle2">{indexedsubjectMrn}</Typography>
        </Box>
        <Box display={'flex'} justifyContent={'row'}>
          <PersonIcon fontSize={'small'} sx={{ marginRight: 1 }} />
          <Typography variant="subtitle2">{indexedsubjectFullName}</Typography>
        </Box>
        <Box display={'flex'} justifyContent={'row'}>
          <ContactMailIcon sx={{ marginRight: 1 }} fontSize={'small'} />
          <Typography variant="body2" sx={{ color: 'text.secondary' }}>
            {indexedsubjectEmail}
          </Typography>
        </Box>
        <Box display={'flex'} justifyContent={'row'}>
          <ContactPhoneIcon sx={{ marginRight: 1 }} fontSize={'small'} />
          <Typography variant="body2" sx={{ color: 'text.secondary' }}>
            {indexedsubjectPhone}
          </Typography>
        </Box>
        <Box display={'flex'} justifyContent={'row'}>
          <CakeIcon sx={{ marginRight: 1 }} fontSize={'small'} />
          <Typography noWrap variant="body2">
            {subjectDOBFormatted ? `${subjectDOBFormatted} (${subjectAge})` : null}
          </Typography>
        </Box>
      </TableCell>

      <TableCell>
        <Typography variant="body2">{workflowStageName}</Typography>
      </TableCell>

      <TableCell>
        <Typography variant="body2">{!!createdOnFormatted && createdOnFormatted}</Typography>
      </TableCell>

      <TableCell>
        <Label
          color={workflowStatus === 'Open' ? 'success' : 'error'}
          sx={{ textTransform: 'uppercase' }}
        >
          {workflowStatus}
        </Label>
      </TableCell>
    </TableRow>
  );
}
